import { debounce } from '@material-ui/core';
import { useEffect, useRef } from 'react';

import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useScreen } from '@/hooks/useScreen';

export const useAutoHideLeftMenu = () => {
  const {
    state: { showLeftMenu },
    actions: { setShowLeftMenu },
  } = usePageContext();
  const { lg } = useScreen();

  const hideCondition = !lg;

  const updateShowLeftMenuDebounced = useRef(debounce(setShowLeftMenu, 100));

  useEffect(() => {
    if (hideCondition && showLeftMenu) {
      updateShowLeftMenuDebounced.current(false);
      return;
    }
    if (!hideCondition && !showLeftMenu) {
      updateShowLeftMenuDebounced.current(true);
    }
  }, [hideCondition]);
};
